export default [
  {
    display: 'Bachelor of Nursing',
    code: 'BN'
  },
  {
    display: 'Bachelor on Science - Nursing',
    code: 'BSN'
  },
  {
    display: 'Certified Adult Nurse Practitioner',
    code: 'CANP'
  },
  {
    display: 'Certified Medical Assistant',
    code: 'CMA'
  },
  {
    display: 'Certified Nurse Midwife',
    code: 'CNM'
  },
  {
    display: 'Certified Nurse Practitioner',
    code: 'CNP'
  },
  {
    display: 'Certified Nurse Specialist',
    code: 'CNS'
  },
  {
    display: 'Certified Pediatric Nurse Practitioner',
    code: 'CPNP'
  },
  {
    display: 'Certified Registered Nurse',
    code: 'CRN'
  },
  {
    display: 'Doctor of Osteopathy',
    code: 'DO'
  },
  {
    display: 'Family Practice Nurse Practitioner',
    code: 'FPNP'
  },
  {
    display: 'Doctor of Medicine',
    code: 'MD'
  },
  {
    display: 'Medical Assistant',
    code: 'MDA'
  },
  {
    display: 'Master of Divinity',
    code: 'MDI'
  },
  {
    display: 'Master of Science - Nursing',
    code: 'MSN'
  },
  {
    display: 'Medical Technician',
    code: 'MT'
  },
  {
    display: 'Nurse Practitioner',
    code: 'NP'
  },
  {
    display: 'Physician Assistant',
    code: 'PA'
  },
  {
    display: 'Advanced Practice Nurse',
    code: 'PN'
  },
  {
    display: 'Doctor of Pharmacy',
    code: 'PharmD'
  },
  {
    display: 'Registered Medical Assistant',
    code: 'RMA'
  },
  {
    display: 'Registered Nurse',
    code: 'RN'
  },
  {
    display: 'Registered Pharmacist',
    code: 'RPH'
  }
]
